





































import { Vue, Component, Prop } from 'vue-property-decorator'
import { ImageFile } from '@/types/image'
import { ExStore } from 'vuex'
import dayjs from 'dayjs'
import { Tabs, TabSettingName } from '@/constants/appSettings'

@Component({
  components: {
    Loading: () => import('@/components/common/loadings/UploadLoading.vue')
  }
})
export default class ImageUpload extends Vue {
  $store!: ExStore
  image: ImageFile | null = null
  description = ''
  loading = false

  @Prop(Number) imageId?: number

  imageIndexRouteName = `${Tabs[TabSettingName.image].routeName}Index`

  get isInApp() {
    return this.$store.getters['image/isInAppBrowser']
  }

  get formatDate() {
    if (!this.image) return ''
    return dayjs(this.image.registeredDatetime).format('M月D日 HH:mm')
  }

  get senderName() {
    if (!this.imageId) return ''
    if (this.image?.worker) {
      return `${this.image.worker.lastName}${this.image.worker.occupation.name}`
    }
    return `${this.userInfo.lastName}${this.userInfo.firstName}`
  }

  get file() {
    return this.$store.getters['image/patientUploadImage']
  }

  get userInfo() {
    return this.$store.getters['user/userInfo']
  }

  get patientId() {
    return this.userInfo.id
  }

  async created() {
    if (this.imageId) {
      await this.fetchImage(this.imageId)
    }
  }

  async handleCancel() {
    if (this.isInApp) {
      await this.$router.replace({ name: 'Hangup' })
      return
    }
    this.$router.push({ name: this.imageIndexRouteName })
  }

  beforeDestroy() {
    this.$store.dispatch('image/updatePatientUploadImage', {
      name: '',
      base64: ''
    })
    if (this.isInApp) this.$router.replace({ name: 'Hangup' })
  }

  async fetchImage(imageId: number) {
    try {
      const res = await this.$api.image.fetchOne({
        patientId: this.patientId,
        imageId: imageId
      })
      this.image = res
      this.description = res.description
      const blob = await this.$api.image.fetchImage({
        patientId: this.patientId,
        imageId
      })
      const reader = new FileReader()
      reader.readAsDataURL(blob)
      reader.onloadend = () => {
        const base64 = reader.result as string
        this.$store.dispatch('image/updatePatientUploadImage', {
          name: '',
          base64
        })
      }
    } catch (e) {
      if (e.message === 'Not Found') {
        this.$router.replace({ name: 'PatientImageList' })
      }
    }
  }

  async upload() {
    //TODO: エラー処理
    this.loading = true
    try {
      if (this.imageId) {
        await this.update(this.imageId)
      } else {
        await this.create()
      }
      if (this.isInApp) {
        await this.$router.push({ name: 'Hangup' })
        return
      }
      localStorage.setItem('message', '保存されました')
      this.$router.push({ name: 'PatientImageList' })
      this.loading = false
    } catch (e) {
      console.error(e)
      this.loading = false
    }
  }

  async create() {
    await this.$api.image.create({
      patientId: this.patientId,
      payload: {
        title: this.file.name.split('.')[0],
        description: this.description,
        fileName: this.file.name,
        fileContent: this.file.base64
      }
    })
  }

  async update(imageId: number) {
    await this.$api.image.patch({
      patientId: this.patientId,
      imageId: imageId,
      payload: {
        description: this.description
      }
    })
  }
}
